import api from 'app/shared/utils/api';
import promise from 'promise';

import DispatchConstants from 'app/shared/constants/DispatchConstants';
import Contract from 'app/shared/model/Contract';

const EnterpriseSingleFamilyActions = {
    getContracts() {
        return dispatch => dispatch(api.users.enterpriseSingleFamily.getContracts())
            .then((response) => {
                if (response.success && response.response) {
                    const contractsModel = response.response.contracts.map(Contract);
                    dispatch({
                        type: DispatchConstants.SINGLE_FAMILY_SET_CONTRACTS,
                        payload: {
                            contracts: contractsModel,
                        },
                    });
                    return contractsModel;
                }
                return promise.reject(response.error);
            });
    },
};

export default EnterpriseSingleFamilyActions;
